// import { useTranslation } from "react-i18next";
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { AutoComplete, Input } from 'antd/es';

const useStyles = createUseStyles({
	modelSearch: {
		position: 'relative',
		top: '10px',
	},
});

const AntdSearchBar = (props) => {
	// const { t, i18n } = useTranslation();
	const classes = useStyles();
	const { onSearchChange, searchModels, handleSelection, query, searchRecommendations } = props;
	const { t } = useTranslation();

	return (
		<AutoComplete
			className={classes.modelSearch}
			popupMatchSelectWidth
			style={{ width: 350, display: 'block', position: 'static' }}
			options={searchRecommendations(query)}
			onSelect={handleSelection}
		>
			<Input.Search
				size='medium'
				placeholder={t('modelSelectView.search', 'search models...')}
				onChange={onSearchChange}
				onSearch={searchModels}
				allowClear
			/>
		</AutoComplete>
	);
};

export default AntdSearchBar;
